module.exports = __webpack_public_path__ + "static/media/Highlight_skelleton-12.6165029a.svg";